import base from './base';
import { permissionComputeds, authorOrPermissionMethods } from './base';

export default {
	mixins: [base],
	computed: permissionComputeds('VIEW_TAG', 'ADD_TAG', 'CHANGE_TAG', 'DELETE_TAG'),
};
